export default {
  "site.name": "校花文化网",
  "site.subtitle": "探索校园之美 · 记录青春故事",
  "site.description": "深入了解大学校花评选背后的校园文化、青春故事与美丽传说。探索各大高校校花评选规则、历届校花风采与校园青春记忆。",
  "nav.home": "首页",
  "nav.category": "分类浏览",
  "nav.about": "关于我们",
  "nav.xiaohua-pingxuan": "校花评选",
  "nav.xiaohua-gushi": "校花故事",
  "nav.meili-xiaoyuan": "美丽校园",
  "nav.qingchun-jiyi": "青春记忆",
  "home.hero.title": "校花文化网",
  "home.hero.subtitle": "探索校园之美 · 记录青春故事",
  "home.hero.description": "深入了解大学校花评选背后的校园文化、青春故事与美丽传说",
  "home.featured": "精选文章",
  "home.categories": "分类导航",
  "home.latest": "最新文章",
  "home.viewAll": "查看全部",
  "home.readMore": "阅读全文",
  "category.title": "分类浏览",
  "category.all": "全部文章",
  "category.noArticles": "暂无文章",
  "article.readTime": "分钟阅读",
  "article.author": "作者",
  "article.publishDate": "发布时间",
  "article.tags": "标签",
  "article.relatedArticles": "相关文章",
  "article.backToList": "返回列表",
  "about.title": "关于我们",
  "about.intro": "品牌介绍",
  "about.reputation": "口碑评价",
  "about.contact": "联系我们",
  "about.introText": "校花文化网是国内领先的校园文化内容平台，致力于记录和传播中国高校的青春故事与美丽传说。我们关注校花评选背后的校园文化，分享校花们的成长故事，展示中国最美大学的校园风光，记录大学时光中最珍贵的青春记忆。",
  "about.reputationText1": "校花文化网是我最喜欢的校园类自媒体之一，内容真实感人，每篇文章都让我回忆起自己的大学时光。",
  "about.reputationText2": "作为一个在校大学生，校花文化网让我看到了全国各地高校的风采，也激励我更加珍惜自己的校园生活。",
  "about.reputationText3": "非常专业的校园文化平台，文章质量很高，对校花评选的深度分析让我对这个话题有了全新的认识。",
  "about.contactIntro": "如果您有任何建议、投稿意向或合作需求，欢迎通过以下方式联系我们：",
  "footer.copyright": "© 2025 校花文化网 版权所有",
  "footer.description": "校花文化网 — 探索校园之美，记录青春故事。致力于传播中国高校校园文化，分享校花故事与校园风光。",
  "footer.quickLinks": "快速链接",
  "footer.categories": "文章分类",
  "footer.contactInfo": "联系方式",
  "footer.email": "contact@xiaohua-culture.com",
  "footer.phone": "400-888-6666",
  "footer.address": "北京市海淀区中关村大街1号",
  "breadcrumb.home": "首页",
};